import { fetchWithAuth } from './utils';

export async function getDeviceMap() {
    const url = new URL(`${process.env.REACT_APP_API_URL}/device/map`);

    const response = await fetchWithAuth(url);

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText);
    }

    return await response.json();
}